module.exports = __webpack_public_path__ + "static/media/video-policy.8b19ee44.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/video-policy.pdf
// module id = 191
// module chunks = 0